/*
 * @Description: 系统设置-用户管理-API
 */

/*
 * @Description: 系统设置-角色管理-API
 */

import { clearFalseValue, formatTableGetParams, formatTableResponse } from '@/utils/utils';
import { httpRequest } from '@/utils/umiRequest';

// 获取用户列表
export async function fetchUsers(data: any, options?: Record<string, any>) {
  const _params = formatTableGetParams(clearFalseValue(data));
  const response = await httpRequest.get('/users', _params, options);
  return formatTableResponse(response);
}

// 获取所有用户列表
export async function fetchSimpleUsers(options?: Record<string, any>) {
  return await httpRequest.get('/simple-users', {}, options);
}

// 新增用户
export async function createUsers(data: any, options?: Record<string, any>) {
  return await httpRequest.post('/users', data, options);
}

// 批量新增用户
export async function importUsers(data: any, options?: Record<string, any>) {
  return await httpRequest.post('/users/import', data, options);
}

// 编辑用户
export async function editUsersAPI(id: string, data: any, options?: Record<string, any>) {
  return await httpRequest.put(`/users/${id}`, clearFalseValue(data), options);
}

// 批量新增用户
export async function deleteUsersAPI(id: string, options?: Record<string, any>) {
  return await httpRequest.delete(`/users/${id}`, {}, options);
}
// 获取所有角色名称
export async function fetchAllRoleAPI(options?: Record<string, any>) {
  return await httpRequest.get('/all-role-permissions', {}, options);
}

// 获取所有角色名称
export async function fetchUserAPI(data: any, options?: Record<string, any>) {
  const _params = formatTableGetParams(clearFalseValue(data));

  let result = [];
  try {
    result = await httpRequest.get('/users/search', _params, options);
  } catch (error) {
    console.error('获取用户列表失败:', error);
  }

  return result;
}

// 改变工单状态
export async function changeStatusAPI(id: number, data: any, options?: Record<string, any>) {
  return await httpRequest.put(`/saas-dispute/change-status/${id}`, data, options);
}
// 修改AI类型
export async function changeAiTypeAPI(id: number, data: any, options?: Record<string, any>) {
  return await httpRequest.put(`/saas-dispute/set_ai_type/${id}`, data, options);
}
//工单指派
export async function saasDisputeAssignAPI(
  data: { ticket_ids: string; responder_id: number },
  options?: Record<string, any>,
) {
  return await httpRequest.put('/saas-dispute/assign', data, options);
}

// 单个指派
export async function userForSingle(
  data: {
    ticket_ids: number | string;
    responder_id: number | string;
  },
  options?: Record<string, any>,
) {
  return httpRequest.put(`/saas-dispute/user-for-single`, data, options);
}

// 判断账号是否有messager权限
export async function isGreyUser(data: { user_id: number }, options?: Record<string, any>) {
  return await httpRequest.post('/is-grey-user', data, options);
}
